import React from 'react';
import moment from 'moment-timezone';
import dayjs from 'dayjs';

export default (data) => {
  const { startDate, endDate, timeZoneTitle } = data;
  const _startDate = timeZoneTitle
    ? moment.tz(startDate, timeZoneTitle)
    : dayjs(startDate);
  const _endDate = timeZoneTitle
    ? moment.tz(endDate, timeZoneTitle)
    : dayjs(endDate);
  return (
    <>
      {_startDate.format('YYYY') === _endDate.format('YYYY') ? (
        <>
          {_startDate.format('MMM') === _endDate.format('MMM') ? (
            <>
              {_startDate.format('MMM')}
              {_startDate.format(' D ')}
              <span>-</span>
              {_endDate.format(' D')}
              <span>,</span>
              {_startDate.format(' YYYY')}
            </>
          ) : (
            <>
              {_startDate.format('MMM D ')}
              <span>-</span>
              {_endDate.format(' MMM D')}
              <span>,</span>
              {_startDate.format(' YYYY')}
            </>
          )}
        </>
      ) : (
        <>
          {_startDate.format('MMM D, YYYY ')}
          <span>-</span>
          {_endDate.format(' MMM D, YYYY')}
        </>
      )}
    </>
  );
};
